import React, { useContext, useEffect, useState } from 'react';
import single_notice_image from '../../assets/images/single_notice_image.png'
import spining_gif from '../../assets/images/spining_gif.gif'
import CashZoneButton from '../CashZoneButton'
import axios from 'axios';
import { useParams } from 'react-router-dom';
import LoginContext from '../../context';

const SingleNoticeSection = () => {
    const { id } = useParams();
    const [notice, setNotice] = useState(null);
    const [loading, setLoading] = useState(true);
    const { token } = useContext(LoginContext)

    useEffect(() => {
        const fetchNotice = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/boards/notices/${id}`, {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${token?.token}`,
                    },
                });
                setNotice(res.data);
            } catch (err) {
                console.error('Failed to fetch notice:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchNotice();
    }, [id, token?.token]);

    // if (loading) {
    //     return (
    //         <div className="flex justify-center items-center h-40 text-white">
    //             <img src={spining_gif} alt="Loading..." className="w-10" />
    //             <span className="ml-2">불러오는 중...</span>
    //         </div>
    //     );
    // }

    // if (!notice) {
    //     return <div className="text-white text-center mt-4">공지사항을 불러올 수 없습니다.</div>;
    // }
    return (
        <>
            <div className='mt-2.5'>
                <div className='font-sans-serif lg:single-notice-heading-font flex justify-between items-center lg:block bg-charcoal lg:bg-graphite text-left  text-white  lg:font-extrabold p-[5px] lg:pl-[25px] lg:pr-0 lg:pt-[15px] lg:pb-3 border-t border-t-slate lg:border-b border-b-slate  border-x-slate border-x lg:border-x-0 '>
                    <h2 className='text-sm font-bold'>
                        <span className='text-gold'>※ </span>
                        {notice?.title}
                        <span className='text-gold'> ※</span>
                    </h2>
                    <div className="text-[9.6px] flex lg:hidden justify-center items-center">
                        <img src={spining_gif} alt="" />
                        <strong className='text-[#009BEC]'> 관리자 </strong>
                        {/* 24/12/22 */}
                        {new Date(notice?.created_at).toLocaleDateString('ko-KR')}

                    </div>
                </div>
                <div className='text-xs text-white tracking-[-1px] align-middle pt-2.5 pb-2 px-[25px] border-b-slate border-b hidden lg:flex justify-between items-center'>
                    <p> 글쓴이
                        <span className='font-bold ml-5'>관리자</span>
                    </p>
                    {/* <p className='font-bold ml-5'>24/12/22</p> */}
                    <p className='font-bold ml-5'>{new Date(notice?.start_date).toLocaleDateString('ko-KR')}</p>
                </div>
                <div className='align-top leading-[18px] text-white text-xs  p-2.5 lg:px-2.5 lg:py-5 border border-slate lg:border-0 lg:border-b lg:border-b-slate flex justify-center min-h-[100px] lg:min-h-auto bg-charcoal lg:bg-transparent'>
                    {/* <img src={single_notice_image} alt="" /> */}
                    <div dangerouslySetInnerHTML={{ __html: notice?.content }} className="w-full max-w-3xl" />

                </div>
                <div className='hidden lg:block h-[50px]'>
                    <div className='hidden  items-center gap-1 pt-1'>
                        <div className=''>
                            <select name="_temp1" id="_temp1" className='w-[150px] text-white text-xs h-[33px] leading-[33px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-[5px] border border-slate bg-obsidian'>
                                <option value="" selected="selected">회원등급</option>
                            </select>
                        </div>
                        <input type="text" name="mb_nick" id="mb_nick" size="20" className='text-white text-xs leading-[33px] h-[33px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-[5px] border border-slate bg-obsidian' />
                        <input type="text" name="regdate" id="regdate" size="18" className='text-white text-xs leading-[33px] h-[33px] transition-[0.2s] align-middle px-[5px] py-0.5 rounded-[5px] border border-slate bg-obsidian' />
                    </div>
                    <div className=''>
                        <textarea name="comment_content" id="comment_content" rows="6" tabindex="21" className='hidden w-full text-white text-xs transition-[0.2s] mx-0 my-2.5 px-[5px] py-0.5 rounded-[5px] border border-slate bg-obsidian'></textarea>
                    </div>
                    <div className='w-fit mx-auto hidden'>
                        <CashZoneButton label="댓글쓰기" link_src="#" active_color="bg-amberGold" active={true} type="link" />
                    </div>
                </div>
                <div className='text-center px-0 py-5 border-dotted lg:border-t-[1px] border-t-[#ffffff40] lg:mb-7 single-notice-section-btn-container'>
                    <CashZoneButton label="목록 " link_src="/notice" active_color="bg-amberGold" active={false} type="link" />
                </div>
            </div>
        </>
    )
}
export default SingleNoticeSection